import Layout from "../cponents/layout";
import { useEffect, useState } from "react";
import BaseEndpoint from "../endpoints/baseEndpoint";

export default function About() {
    const [data, setData] = useState(null);

    useEffect(() => {
        BaseEndpoint.instance().get('/web-instruction/about').then((res) => {
            if (res.status === 200) {
                setData(res.data);
            }
        });
    }, []);

    return (
        <Layout>
            <div className="container py-5 row mx-auto align-items-center">
                <h2 className="mb-3">{data?.title || 'Tentang Kami'}</h2>
                <div className="about" dangerouslySetInnerHTML={{ __html: data?.content || '' }} />
            </div>
        </Layout>
    )
}